<template>
  <div
    class="col-12 card mb-0 d-flex justify-content-center"
    :class="`${mode == 'table' ? '' : 'm-0 shadow card-body '}`"
    :style="`height: ${mode == 'table' ? 'auto' : '60vh'};${
      color
        ? 'background:' + color + ';border-color: ' + color + '!important;'
        : ''
    }`"
  >
    <div
      :class="`${
        mode == 'table' ? 'px-0' : ''
      }  d-flex justify-content-center py-2`"
    >
      <img src="/img/load.svg" style="max-height: 60px" />
    </div>
    <div class="col-auto mx-auto" v-if="message">
      <h3 v-html="message"></h3>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["mode", "message", "color"],
  };
</script>
